<template>
  <div class="text-left">
    <h5>
      <span
        class="uppercase"
        v-text="t('forms.new_contractor_company.IC_0030')"/>
    </h5>

    <span
      class="button mini radius no-margin"
      @click="copyAddress"
      v-text="t('register.copy_admin_info')"/>
    <hr>

    <div
      class="panel"
      v-text="t('forms.new_contractor_company.IC_0031')"/>

    <label>
      <span v-text="t('forms.new_contractor_company.IC_0032')"/>
      <i
        class="fa fa-question-circle"
        @click="showLegalNameModal = true"/>
      <i
        class="text-red"
        v-text="t('register.change_company_name')"/>
      <input
        v-model="localData.memberInfo.Name"
        type="text"
        disabled>
    </label>

    <label>
      <span v-text="t('forms.new_contractor_company.IC_0042')"/>
      <i
        class="fa fa-question-circle"
        @click="showOperatingAsModal = true"/>
      <input
        v-model="localData.memberInfo.OperatingAs"
        type="text">
    </label>

    <label class="bottomMargin">
      <span v-text="t('forms.new_contractor_company.IC_0033')"/>
      <span class="required">*</span>
      <input
        v-model="localData.memberInfo.Street"
        type="text"
        class="no-margin">
      <small
        v-if="streetError && displayError"
        class="error"
        v-text="t('xajax.mycontactinfo.server.IC_0014')"/>
    </label>

    <label class="bottomMargin">
      <span v-text="t('forms.new_contractor_company.IC_0034')"/>
      <span class="required">*</span>
      <input
        v-model="localData.memberInfo.City"
        type="text"
        class="no-margin">
      <small
        v-if="cityError && displayError"
        class="error"
        v-text="t('xajax.mycontactinfo.server.IC_0015')"/>
    </label>

    <label class="bottomMargin">
      <span v-text="t('forms.new_contractor_contact.IC_0011')"/>
      <span class="required">*</span>
      <select
        v-model="localCountryId"
        class="no-margin">
        <option
          value="0"
          v-text="t('admin.edit_question.IC_0000')"/>
        <option
          v-for="country in displayData.geoInfo.countries"
          :value="country.CountryID"
          v-text="country.Name"/>
      </select>
      <small
        v-if="countryError && displayError"
        class="error"
        v-text="t('xajax.mycontactinfo.server.IC_0017')"/>
    </label>

    <label
      v-if="localCountryId !== '0'"
      class="bottomMargin">
      <span v-text="t('forms.new_contractor_contact.IC_0010')"/>
      <span class="required">*</span>
      <select
        v-model="localProvinceId"
        class="no-margin">
        <option
          value="0"
          v-text="t('admin.edit_question.IC_0000')"/>
        <option
          v-for="province in getProvinces()"
          :value="province.zone_id"
          v-html="province.Name"/>
      </select>
      <small
        v-if="provinceError && displayError"
        class="error"
        v-text="t('xajax.mycontactinfo.server.IC_0016')"/>
    </label>

    <label class="bottomMargin">
      <span v-text="t('forms.new_contractor_company.IC_0037')"/>
      <span class="required">*</span>
      <input
        v-model="localData.memberInfo.Postal"
        class="no-margin"
        type="text">
      <small
        v-if="postalError && displayError"
        class="error no-margin"
        v-text="t('xajax.mycontactinfo.server.IC_0018')"/>
      <small
        v-if="postalMatchError && displayError"
        class="error"
        v-text="t('member_basic_edit.IC_0115')"/>
    </label>

    <label class="bottomMargin">
      <span v-text="t('forms.new_contractor_company.IC_0038')"/>
      <span class="required">*</span>
      <input
        v-model="localData.memberInfo.MainTel"
        type="text"
        class="no-margin">
      <small
        v-if="mainTelError && displayError"
        class="error"
        v-text="t('xajax.mycontactinfo.server.IC_0011')"/>
    </label>

    <label>
      <span v-text="t('forms.new_contractor_company.IC_0039')"/>
      <input
        v-model="localData.memberInfo.MainFax"
        type="text">
    </label>

    <label>
      <span v-text="t('forms.new_contractor_company.IC_0040')"/>
      <input
        v-model="localData.memberInfo.MainEmail"
        type="text">
    </label>

    <label>
      <span v-text="t('forms.new_contractor_company.IC_0041')"/>
      <input
        v-model="localData.memberInfo.Website"
        type="text">
    </label>

    <label>
      <span v-text="t('member_basic_edit.IC_0073')"/>
      <span v-if="taxMandatory" class="required">*</span>
      <input
        v-model.trim="localData.memberInfo.GST"
        type="text">
      <small
        v-if="taxError && displayError"
        class="error"
        v-text="t('xajax.newcontractor.server.IC_0072')"/>
    </label>

    <div class="row">
      <div class="columns large-4">
        &nbsp;
      </div>
      <div class="columns large-4">
        <button
          @click="openGuide"
          class="tiny radius expand"
          v-text="t('register.user_guide')"/>
      </div>
      <div class="columns large-1">
        &nbsp;
      </div>
      <div class="columns large-3">
        <button
          class="tiny radius expand"
          @click="nextStep"
          v-text="t('member_basic_edit.IC_0013')"/>
      </div>
    </div>

    <modal
      v-if="showLegalNameModal"
      :size="`small`"
      :show-close-button="true"
      @close="showLegalNameModal = false">
      <p v-html="legalNameHtml"/>
    </modal>

    <modal
      v-if="showOperatingAsModal"
      :size="`small`"
      :show-close-button="true"
      @close="showOperatingAsModal = false">
      <p v-html="operatingAsHtml"/>
    </modal>

  </div>

</template>

<script>
import _      from 'lodash';
import toastr from 'toastr';
import $      from 'jquery';
import Modal  from '../../Ui/Modal.vue';

export default {

  components: {
    Modal,
  },

  props: ['displayData'],

  data() {
    return {
      localData: {},
      legalNameHtml: '',
      operatingAsHtml: '',
      localCountryId: '0',
      localProvinceId: '0',
      showLegalNameModal: false,
      showOperatingAsModal: false,
      displayError: true,
    };
  },

  computed: {
    compoundProperty() {
      this.localData.memberInfo && this.localData.memberInfo.Street;

      return Date.now();
    },

    countryError() {
      return this.localCountryId === '0';
    },

    streetError() {
      return _.isEmpty(this.localData.memberInfo.Street);
    },

    cityError() {
      return _.isEmpty(this.localData.memberInfo.City);
    },

    provinceError() {
      return this.localProvinceId == 0;
    },

    mainTelError() {
      return _.isEmpty(this.localData.memberInfo.MainTel)
        || _.size(this.localData.memberInfo.MainTel) < 9;
    },

    postalError() {
      return _.isEmpty(this.localData.memberInfo.Postal);
    },

    postalMatchError() {
      let error = false;

      if (this.localData.memberInfo.CountryISO !== 'CA' || this.provinceError) {
        return false;
      }

      const postal = this.localData.memberInfo.Postal.replace(/[^a-z0-9]/gi, '').toUpperCase();

      if (_.size(postal) !== 6) {
        error = true;
      }

      if (_.includes(['W', 'Z'], postal.charAt(0))) {
        error = true;
      }

      ['D', 'F', 'I', 'O', 'Q', 'U'].forEach((char) => {
        if (_.includes(postal, char)) {
          error = true;
        }
      });

      const regex = /^[A-Z]\d[A-Za-z]\d[A-Z]\d$/;
      const match = regex.exec(postal);

      if (!match) {
        error = true;
      }

      const provincePostalDistrictMap = new Map();

      provincePostalDistrictMap.set('AB', ['T']);
      provincePostalDistrictMap.set('BC', ['V']);
      provincePostalDistrictMap.set('MB', ['R']);
      provincePostalDistrictMap.set('NB', ['E']);
      provincePostalDistrictMap.set('NL', ['A']);
      provincePostalDistrictMap.set('NT', ['X']);
      provincePostalDistrictMap.set('NS', ['B']);
      provincePostalDistrictMap.set('NU', ['X']);
      provincePostalDistrictMap.set('ON', ['K', 'L', 'M', 'N', 'P']);
      provincePostalDistrictMap.set('PE', ['C']);
      provincePostalDistrictMap.set('NS', ['B']);
      provincePostalDistrictMap.set('QC', ['G', 'H', 'J']);
      provincePostalDistrictMap.set('SK', ['S']);
      provincePostalDistrictMap.set('YT', ['Y']);

      const firstLetter = provincePostalDistrictMap.get(this.localData.memberInfo.ProvinceISO);

      if (!_.includes(firstLetter, postal.charAt(0))) {
        error = true;
      }

      return error;
    },

    taxError() {
      return _.isEmpty(this.localData.memberInfo.GST) && this.localData.requiredTaxId.includes(this.localCountryId);
    },

    taxMandatory() {
      return this.localData.requiredTaxId.includes(this.localCountryId);
    },
  },

  watch: {
    compoundProperty: _.debounce(function () {
      this.saveCompanyContact();
    }, 500),

    localCountryId(val, oldVal) {
      const match = _.find(this.displayData.geoInfo.countries, country =>
        country.CountryID === val);

      if (match) {
        this.localData.memberInfo.Country = match.Name;
        this.localData.memberInfo.CountryCode = match.iso_code_2;
        this.localData.memberInfo.CountryISO = match.iso_code_2;
      } else {
        this.localData.memberInfo.Country = '';
        this.localData.memberInfo.CountryCode = '';
        this.localData.memberInfo.CountryISO = '';
      }

      if (val !== oldVal && oldVal > 0) {
        this.localProvinceId = 0;
      }
    },

    localProvinceId(val) {
      const match = _.find(this.displayData.geoInfo.provinces, province =>
        province.zone_id === val);

      if (match) {
        this.localData.memberInfo.Province = match.Name;
        this.localData.memberInfo.ProvinceISO = match.code;
      } else {
        this.localData.memberInfo.Province = '';
        this.localData.memberInfo.ProvinceISO = '';
      }
    },
  },

  mounted() {
    $.get('/information.php?t=legal-business-name', (data) => { this.legalNameHtml = data; return false; });
    $.get('/information.php?t=operating-as', (data) => { this.operatingAsHtml = data; return false; });
  },

  activated() {
    this.localData = _.cloneDeep(this.displayData);

    this.init();
  },

  beforeMount() {
    this.localData = _.cloneDeep(this.displayData);

    this.init();
  },

  methods: {
    openGuide() {
      window.open(t('register.user_guide_link'), '_blank')
    },

    init() {
      const countryCode = this.localData.memberInfo.CountryISO ?
        this.localData.memberInfo.CountryISO :
        this.localData.memberInfo.Country && _.size(this.localData.memberInfo.Country) === 2 ?
          this.localData.memberInfo.Country : false;


      if (!_.isEmpty(countryCode)) {
        const match = _.find(this.displayData.geoInfo.countries, country =>
          country.iso_code_2 === countryCode);

        if (match) {
          this.localCountryId = match.CountryID;
          this.localData.memberInfo.Country = match.Name;
          this.localData.memberInfo.CountryCode = match.iso_code_2;
          this.localData.memberInfo.CountryISO = match.iso_code_2;
        }
      }

      const provinceCode = this.localData.memberInfo.ProvinceISO ?
        this.localData.memberInfo.ProvinceISO :
        this.localData.memberInfo.Province ?
          this.localData.memberInfo.Province : false;

      if (!_.isEmpty(provinceCode) && !_.isEmpty(countryCode)) {
        const match = _.find(this.displayData.geoInfo.provinces, province =>
          province.code === provinceCode && province.CountryID === this.localCountryId);

        if (match) {
          this.localProvinceId = match.zone_id;
          this.localData.memberInfo.Province = match.Name;
          this.localData.memberInfo.ProvinceISO = match.code;
        }
      }
    },

    copyAddress() {
      this.localCountryId = this.localData.adminInfo.CountryISO;

      this.localData.memberInfo.Street = this.localData.adminInfo.Street;
      this.localData.memberInfo.City = this.localData.adminInfo.City;
      this.localData.memberInfo.Country = this.localData.adminInfo.Country;
      this.localData.memberInfo.Province = this.localData.adminInfo.Province;
      this.localData.memberInfo.CountryISO = this.localData.adminInfo.CountryISO;
      this.localData.memberInfo.ProvinceISO = this.localData.adminInfo.ProvinceISO;
      this.localData.memberInfo.Postal = this.localData.adminInfo.Postal;
      this.localData.memberInfo.MainTel = this.localData.adminInfo.Tel;
      this.localData.memberInfo.MainEmail = this.localData.adminInfo.Email;

      this.init();
    },

    saveCompanyContact() {
      $.post('/register/save-company', { memberInfo: this.localData.memberInfo });

      return false;
    },

    nextStep() {
      if (this.checkComplete()) {
        this.$emit('display-change', this.localData);
        this.$emit('tab-change', 1);
      } else {
        toastr.error(t('register.validation_errors_found'));
      }


      return false;
    },

    checkComplete() {
      return !this.countryError && !this.streetError
        && !this.cityError && !this.provinceError
        && !this.mainTelError && !this.postalError
        && !this.postalMatchError && !this.taxError;
    },

    getProvinces() {
      return _.filter(this.displayData.geoInfo.provinces, province =>
        province.CountryID === this.localCountryId);
    },
  },
};
</script>
<style type="text/css">
.uppercase {
  text-transform: capitalize;
}
</style>
